import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["file", "selection", "image", "placeholder"]
  static values = { selection: String }

  disconnect() {
    this.#revokePreview()
  }

  confirm({ detail }) {
    if (detail.targetId !== this.element.id) return

    if (detail.kind === "preset") {
      this.selectionTarget.value = detail.preset
      this.fileTarget.value = ""
      this.selectionValue = `preset:${detail.preset}`
      this.#showPreview(detail.previewUrl, detail.label)
    } else {
      this.selectionTarget.value = ""
      this.selectionValue = "upload"
      if (detail.files.length > 0) {
        this.fileTarget.files = detail.files
        this.#showPreview(URL.createObjectURL(detail.files[0]), detail.files[0].name, true)
      }
    }

    this.dispatch("change")
  }

  #showPreview(url, alt, objectUrl = false) {
    this.#revokePreview()
    this.previewObjectUrl = objectUrl ? url : null
    this.imageTarget.src = url
    this.imageTarget.alt = alt
    this.imageTarget.hidden = false
    this.placeholderTarget.hidden = true
    this.element.querySelector(".image-selectable__change-label").textContent = "Change image"
  }

  #revokePreview() {
    if (!this.previewObjectUrl) return

    URL.revokeObjectURL(this.previewObjectUrl)
    this.previewObjectUrl = null
  }
}
